import { SIMULATION_TARGETS } from './simulations';

export const CREDIT_TYPES_NAMES = {
  [SIMULATION_TARGETS.PERSON]: 'Personal',
  [SIMULATION_TARGETS.CAR]: 'Auto',
  [SIMULATION_TARGETS.MOTORCYCLE]: 'Moto',
  [SIMULATION_TARGETS.EMOBILE]: 'Crédito',
  [SIMULATION_TARGETS.CELLPHONE]: 'Celular'
};
